import { render, staticRenderFns } from "./Disclaimers.vue?vue&type=template&id=745c4717&scoped=true"
import script from "./Disclaimers.vue?vue&type=script&lang=js"
export * from "./Disclaimers.vue?vue&type=script&lang=js"
import style0 from "./Disclaimers.vue?vue&type=style&index=0&id=745c4717&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745c4717",
  null
  
)

export default component.exports